import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import CategoryNav from '@/components/feature/CategoryNav';
import PlatformCard from '@/components/feature/PlatformCard';
import { platforms, categories } from '@/mocks/platforms';

const categoryMetaMap: Record<string, { title: string; description: string; keywords: string }> = {
  dianying: {
    title: '免费电影平台推荐 | 正版高清电影在线观看平台汇总',
    description: '汇总2024年最全正版免费电影平台，涵盖动作、喜剧、爱情、科幻、悬疑等类型，高清画质流畅播放，无需付费安全合规，免费看电影的最佳选择。',
    keywords: '免费电影,免费看电影平台,正版免费电影,免费高清电影在线观看,免费电影网站推荐',
  },
  dianshiju: {
    title: '免费电视剧追剧平台推荐 | 正版高清电视剧免费观看汇总',
    description: '推荐2024年最好的免费电视剧平台，国产剧、韩剧、美剧、日剧应有尽有，更新及时画质清晰，免费追剧好去处。',
    keywords: '免费电视剧,免费追剧网站,正版免费电视剧,免费看电视剧平台,免费追剧平台推荐',
  },
  jilupian: {
    title: '免费纪录片平台推荐 | 高清正版纪录片在线观看汇总',
    description: '精品纪录片免费看平台推荐，自然、历史、科技、人文各类题材，BBC、Discovery等正版内容，开阔视野增长知识。',
    keywords: '免费纪录片,纪录片平台推荐,正版纪录片免费看,高清纪录片在线观看,BBC纪录片免费',
  },
  dongman: {
    title: '免费动漫平台推荐 | 正版日漫国漫免费在线观看汇总',
    description: '热门动漫番剧免费在线看平台推荐，日漫新番同步追、国漫精品不错过，高清流畅不卡顿，二次元的免费观影天堂。',
    keywords: '免费动漫,免费看动漫平台,正版日漫免费,国漫免费看,免费追番网站推荐',
  },
  zongyi: {
    title: '免费综艺平台推荐 | 热门综艺节目免费在线观看汇总',
    description: '热门综艺节目免费看平台推荐，音乐、脱口秀、真人秀、竞技类节目精彩不断，免费享受顶级综艺娱乐内容。',
    keywords: '免费综艺,综艺平台推荐,免费看综艺节目,正版综艺在线观看,热门综艺免费看',
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const meta = slug ? categoryMetaMap[slug] : null;

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-20 pb-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center py-20">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 text-sm">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const categoryPlatforms = platforms.filter((p) => p.categories.includes(slug || ''));

  const breadcrumbItems = [
    { label: '首页', path: '/' },
    { label: category.name },
  ];

  const itemListSchema = {
    itemListElement: categoryPlatforms.map((p, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@type': 'Article',
        name: p.name,
        url: `https://readdy.ai/article/${p.slug}`,
      },
    })),
  };

  return (
    <>
      <SEOHead
        title={meta?.title || `${category.name}平台推荐`}
        description={meta?.description || category.description}
        keywords={meta?.keywords || ''}
        canonicalUrl={`https://readdy.ai/category/${slug}`}
      />
      <SchemaOrg type="ItemList" data={itemListSchema} />
      <Navbar />
      <main className="min-h-screen">
        <div className="bg-background-100/60 pt-20 pb-10">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  免费{category.name}平台推荐
                </h1>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
                  {category.description}
                </p>
              </div>
              <CategoryNav />
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          {categoryPlatforms.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
              {categoryPlatforms.map((platform) => (
                <PlatformCard key={platform.id} {...platform} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-foreground-500">暂无该分类的平台推荐，敬请期待</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}